import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useHttpClient } from '../../../../shared/http-client';
import { PageBody } from '../../../../elements/page-body';
import { MapContainer, Marker, TileLayer } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import ReactDOMServer from 'react-dom/server';
import { divIcon, Point } from 'leaflet';

// Corrige el problema del icono del marcador que no aparece en producción
L.Marker.prototype.options.icon = L.icon({
    iconUrl: '/images/marker-icon.png',
    shadowUrl: '/images/marker-shadow.png',
    iconSize: [25, 41], // Tamaño del icono
    iconAnchor: [12, 41], // Punto del icono que corresponde a la ubicación del marcador
    popupAnchor: [1, -34], // Punto desde el cual se abrirá el popup
    shadowSize: [41, 41] // Tamaño de la sombra
});





export const UltimaPosicionTab = ({
    item,
    onAction
}: {
    item?: any;
    onAction: () => void;
}) => {

    const { t } = useTranslation() as { t: (key: string) => string };
    const { api, state } = useHttpClient();
    const [data, setData] = useState<any | null>(null);

    // Load initial data
    useEffect(() => {
        if (item) {
            api(`/fleet/vehicles/${item}/`, 'GET');
        }
    }, [item]);

    const defaultCenter: [number, number] = [43.509865, -0.118092];
    const [initialCenter, setInitialCenter] = useState<[number, number]>(defaultCenter);

   const createNumberedIcon = (number: number, color: string) => {
       const markerHtml = ReactDOMServer.renderToStaticMarkup(
           <div style={{ position: 'relative', width: '32px', height: '32px' }}>
               <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32">
                   <path fill={color} d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
               </svg>
           </div>
       );
   
       return divIcon({
           html: markerHtml,
           className: 'custom-div-icon',
           iconSize: new Point(32, 32),
           iconAnchor: new Point(16, 32),
           popupAnchor: new Point(0, -32),
       });
   };
   

    // Handle API responses
    useEffect(() => {
        if (state.data) {
            if (state.path.includes('fleet/vehicles')) {
                /* if (state.method === 'PATCH') {
                    toast.success(`${t('common.label.success-saved')}`);
                    window.location.reload();

                } */
                if (state.method === 'GET') {
                    setData(state.data)

                }
            }
        }

        if (state.error) {
            if (state.error.name) {
                toast.error(state.error.name[0]);
            }
        }
    }, [state]);

    if (!data) {
        return <div>Loading...</div>;
    }

    if (!data.lat || !data.lon) {
        return <div className='flex justify-center mt-24 font-light text-[24px] text-primary'>{t('common.label.no-ultima-posicion-detectada')}</div>;
    }

    const markerPosition: [number, number] = [data.lat, data.lon];
    const customIcon = createNumberedIcon(1, 'red-500');

    return (
        <>
            <div style={{ height: '400px', width: '100%' }}>
                <MapContainer
                    center={markerPosition}
                    zoom={7}
                    style={{ height: '100%', width: '100%' }}
                >
                    <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    />
                    <Marker position={markerPosition} icon={customIcon}></Marker>
                </MapContainer>
            </div>
        </>
    );
};